import { render, staticRenderFns } from "./ContainerWithMenu.vue?vue&type=template&id=2061718b&"
import script from "./ContainerWithMenu.vue?vue&type=script&lang=js&"
export * from "./ContainerWithMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports